import React from 'react'
import browserHistory from 'browserHistory'
import { compose } from 'recompose'

function ComponentWithHashHistory(WrappedComponent) {
  return function WrappedComponentWithHashHistory(props) {
    const [blockId, setBlockId] = React.useState(0)

    React.useEffect(() => {
      const getCurrentHash = () => window.location.hash.slice(1)
      setBlockId(getCurrentHash())
      return browserHistory.listen(() => {
        setBlockId(getCurrentHash())
      })
    }, [])

    return <WrappedComponent {...props} blockId={blockId} />
  }
}

export default ({ BlockLinkPlugin }) => ({
  decorator = x => x,
  getFullNotePath,
  getNoteId,
} = {}) => {
  return BlockLinkPlugin({
    getFullNotePath,
    getNoteId,
    decorator: compose(
      decorator,
      ComponentWithHashHistory
    ),
  })
}
